import get from 'lodash/get';

const translated = {};

export default function (key, replace = {}) {
  let translation = get(window.globalConfig.translation, key, key);

  Object.keys(replace)
    .forEach((option) => {
      translation = translation.split(`:${option}`).join(replace[option]);
    });

  translated[key] = translation;

  return translation;
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/t.js